import React from 'react';
import Text from '../../components/Text';

export default function OAuthError(props) {
  return (
    <div>
      <h2>{ props.error }</h2>
      <div>
        <Text value="Follow the link sent to you by your lender to try again." />
      </div>
    </div>
  );
}
